import React from 'react';

const VideoSection = () => {
  // Import the existing VideoSection component
  const OriginalVideoSection = require('../../components/VideoSection').default;
  
  return <OriginalVideoSection />;
};

export default VideoSection; 